/**
 * call integration - Call Agent Status List
 */
// import logReport from '@/util/logReport'

import apiEvent from '@/util/call/apiEvent';

const getDefaultState = () => {
  return {
    callAgentList: [],
    intervalId: null
  };
};
const state = getDefaultState();

const getters = {
  callAgentList: (state) => {
    return state.callAgentList;
  },
  getAgentListIntervalId: (state) => {
    return state.intervalId;
  }
};

const actions = {};

const mutations = {
  changeCallAgentList(state, callAgentList) {
    state.callAgentList = callAgentList;
  },
  CLEAR_CALL_AGENT_LIST(state) {
    Object.assign(state, getDefaultState());
  },
  FETCH_CALL_AGENT_LIST(state) {
    // 5초에 한번씩 콜상담 상담사 목록을 요청하는 api를 호출한다.
    // 네오메카 / 네오메카 webRTC만 사용
    state.intervalId = setInterval(() => {
      apiEvent.fetchAgentList();
    }, 5000);
  },
  CLEAR_FETCH_CALL_AGENT_LIST_INTERVAL(state) {
    // 소켓이 끊어지는 등 이슈가 발생하면 목록 요청을 중단한다.
    if (state.intervalId) {
      clearInterval(state.intervalId);
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/call/agentStatus.js